import api from "./axios";
import type { Honor, HonorLevel } from "../types";

interface CreateHonorData {
  camperId: number;
  activityId: number;
  level: HonorLevel;
  year: number;
  earnedDate?: string;
  notes?: string;
}

export const honorsApi = {
  list: async (params?: { camperId?: number; year?: number; cabinGroupId?: number }): Promise<Honor[]> => {
    const res = await api.get<Honor[]>("/honors", { params });
    return res.data;
  },

  create: async (data: CreateHonorData): Promise<Honor> => {
    const res = await api.post<Honor>("/honors", data);
    return res.data;
  },

  update: async (id: number, data: Partial<CreateHonorData>): Promise<Honor> => {
    const res = await api.put<Honor>(`/honors/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/honors/${id}`);
  },
};
